import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {ItemLink} from '../ItemLink/ItemLink';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export const Name = ({lineItem}: {lineItem: LineItemModel}) => {
  const {name} = lineItem;

  return (
    <p data-hook={CartItemDataHook.Name} className={s.productName}>
      <ItemLink className={s.productNameLink} lineItem={lineItem}>
        {name}
      </ItemLink>
    </p>
  );
};
